import { PlankPatternForm } from "./PlankPattern.form";

export const HerringbonePatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="herringbone"
    width={{ value: "10", min: 5, max: 30 }}
    height={{ value: "40", min: 20, max: 100 }}
  />
);
